export class Test{

    constructor(){
        alert('aaa');
    }
}